import { useState, type ReactNode } from 'react'
import { SessionContext, type SessionValue, type Staff } from '@/app/session'
import { can } from '@/shared/domain/rbac'
import type { Role } from '@/shared/domain/types'

/// Хто за касою.
///
/// Поки що персонал приходить із заглушки: автентифікація стоїть етапом 1 разом
/// із RBAC, але вона впирається в те, як eatlete входить у наш auth — окреме
/// рішення, яке не варто вгадувати всередині каркаса. Важливо інше: КОНТРАКТ
/// уже справжній, тож екрани будуються на `allows()` з першого дня і не
/// доведеться потім вишукувати місця, де права «забули».
const DEV_STAFF: Staff = {
  id: 'dev-staff',
  name: 'Рецепція (dev)',
  role: 'manager',
  branchId: 'dev-branch',
  branchName: 'Демо-філія',
}

/// Роль переживає перезавантаження: інакше кожна перевірка гейтів починалась би
/// з перемикання, а на екранах, які самі себе перезавантажують, її взагалі не
/// втримати.
const STORAGE_KEY = 'eatlete.dev.role'

const ROLES: readonly Role[] = ['receptionist', 'manager', 'trainer', 'owner']

const storedRole = (): Role => {
  const saved = window.localStorage.getItem(STORAGE_KEY)
  return ROLES.find((role) => role === saved) ?? DEV_STAFF.role
}

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [role, setRole] = useState<Role>(storedRole)
  const staff: Staff = { ...DEV_STAFF, role }

  const value: SessionValue = {
    staff,
    allows: (capability) => can(staff.role, capability),
    actAs: (next) => {
      window.localStorage.setItem(STORAGE_KEY, next)
      setRole(next)
    },
    signOut: () => window.location.assign('/login'),
  }

  return <SessionContext.Provider value={value}>{children}</SessionContext.Provider>
}
